function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritelikeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 154 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.4,33.7C27.4,40.6 23.6,43.1 20.1,43.1C19,43.1 16.4,42.9 14.5,40.6C12.8,42.8 10.5,43.1 9.4,43.1C5.7,43.1 2.3,40.6 2.3,33.7L2.3,6.7C2.3,3.7 1.6,2.6 0.2,2.1C0.1,2.1 0,2.1 0,2C0,1.5 2.1,0 3.8,0C5.3,0 6.9,1.4 6.9,6.2L6.9,34.3C6.9,38.8 8.9,38.8 9.7,38.8C10.6,38.8 12.5,38.8 12.5,33.7L12.5,4.7C12.5,3.6 12.3,3.2 12.3,2.8C12.3,2.2 13,1.8 13.8,1.8C15.8,1.8 17.1,3 17.1,4.4L17.1,34.3C17.1,38.8 19,38.8 19.9,38.8C20.7,38.8 22.7,38.8 22.7,34.3L22.7,6.2C22.7,1.4 24.4,0 25.8,0C27.5,0 29.6,1.4 29.6,2C29.6,2.1 29.5,2.2 29.4,2.2C27.9,2.7 27.3,3.8 27.3,6.8L27.3,33.7L27.4,33.7Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2,36.3C38.2,32.5 39.3,28.3 41.2,23.2L36,23.2C35.9,25.5 35.6,30.7 34.5,34.1C33.7,36.6 30.7,34.5 31.2,32.4C31.9,30 32.1,25.1 32.1,22.1C30.6,21.3 29.6,20 29.6,18.3C29.6,16.6 31,15.6 32.6,15.6C34,15.6 35.7,16.3 36.3,18.7C38.3,18.9 38.8,18.9 39.4,18.9L42.5,18.9C43.2,18.9 45.6,20.9 45.3,22.2C45.3,22.9 42.6,29.9 42.6,35.8C42.6,37.5 43.4,39 45,39C47.7,39 48.7,35.2 49.3,32.6C49.5,31.4 50.1,30.8 50.7,30.8C51.6,30.8 52.8,32.1 52.8,33.2C52.8,33.4 52.7,33.5 52.7,33.6C51.6,37.5 49.3,42.8 44.2,42.8C41.5,43.1 38.2,41.5 38.2,36.3Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1,9.3C49.1,7.2 50.7,5.7 52.7,5.7C54.8,5.7 56.3,7.2 56.3,9.3C56.3,11.3 54.8,12.9 52.7,12.9C50.7,13 49.1,11.3 49.1,9.3ZM54,36.5C54,37 54,39.2 55.5,39.2C57.9,39.2 58.9,35.4 59.5,32.8C60.2,29.2 63.4,32 62.9,33.9C61.8,37.8 59.5,43.1 54.4,43.1C51.3,43.1 49.4,40.6 49.4,37.5L49.4,21.7C49.4,20.6 49.2,20.2 49.2,19.8C49.2,19.2 49.9,18.8 50.7,18.8C52.7,18.8 53.9,20 53.9,21.4L53.9,36.5L54,36.5Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8,13.8L59.8,3.8C59.8,2.1 59.2,2 59.2,1.6C59.2,1.2 60.3,0.9 61.1,0.9C63.1,0.9 64.3,2.1 64.3,3.5L64.3,13.9C67.9,13.9 72.1,13.8 76.1,13.7C77.8,11.9 77.2,17.6 75.7,17.7C71,17.8 67.5,17.8 64.3,17.8L64.3,36.6C64.3,38.5 65.1,39.3 66.3,39.3C68.7,39.3 69.7,35.5 70.3,32.9C70.5,31.7 71.1,31.1 71.7,31.1C72.6,31.1 73.8,32.4 73.8,33.5C73.8,33.6 73.8,33.7 73.7,33.9C72.7,37.8 70.3,43.1 65.2,43.1C62,43.1 59.8,41.2 59.8,36.5L59.8,17.7C57.2,17.7 55.7,17.6 55.7,17.6C53.8,17.6 52.7,13.6 54.5,13.6C54.4,13.6 56.6,13.7 59.8,13.8Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,35.5C76.1,37.5 77.7,39.2 80.8,39.2C85.4,39.2 87.3,35.4 88,31.7C88.5,29 91.8,30.2 91.6,32.3C91.2,35.9 88.8,43.1 80.1,43.1C74.7,43.1 69.6,38.8 69.6,31.4C69.6,23.9 74.1,18.3 78.7,18.3C82,18.3 84,20.7 84,24.3C84.1,28.6 81.1,33.8 75.3,35.5ZM74.6,32.2C77.6,30.8 79.5,27.8 79.5,24.2C79.5,22.9 79,22.1 78.3,22.1C75.4,22.1 74.5,28.6 74.6,31.1L74.6,32.2Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.4,33.9C103.3,37.1 100.4,43.1 95.1,43.1C90.5,43.1 88.1,40 88.1,35.3L88.1,8.3C88.1,3.9 90.5,0.7 93.5,0.7C98.7,0.7 98.8,6.9 98.8,10.2C98.8,18.9 93.4,30.9 92.6,31.6L92.6,35C92.6,37.4 93.5,39.1 95.7,39.1C98.4,39.1 100.4,35.4 101,32.8C101.7,29.3 104.9,32 104.4,33.9ZM92.5,23.9C93.7,21.4 95,13.6 95,10.3C95,6.4 94.3,4.6 93.4,4.6C92.7,4.6 92.5,6 92.5,7L92.5,23.9Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,9.3C100.7,7.2 102.3,5.7 104.3,5.7C106.4,5.7 107.9,7.2 107.9,9.3C107.9,11.3 106.4,12.9 104.3,12.9C102.3,13 100.7,11.3 100.7,9.3ZM105.6,36.5C105.6,37 105.6,39.2 107.1,39.2C109.5,39.2 110.5,35.4 111.1,32.8C111.8,29.2 115,32 114.5,33.9C113.4,37.8 111.1,43.1 106,43.1C102.9,43.1 101,40.6 101,37.5L101,21.7C101,20.6 100.8,20.2 100.8,19.8C100.8,19.2 101.5,18.8 102.3,18.8C104.3,18.8 105.5,20 105.5,21.4L105.5,36.5L105.6,36.5Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,5C111.3,3.3 110.7,3.2 110.7,2.8C110.7,2.4 111.8,2.1 112.6,2.1C114.6,2.1 115.8,3.3 115.8,4.7L115.8,23.2C117.7,20.6 120.1,18.3 122.7,18.3C126.4,18.3 128,21.4 128,24.7C128,29.3 124.7,32.6 122.3,34.3C122.9,36.8 124.2,39.2 126.5,39.2C129.2,39.2 131.2,35.5 131.8,32.9C132.5,29.3 135.7,32.1 135.2,34C134.1,37.2 131.2,43.2 125.9,43.2C121.2,43.2 118.1,37.9 118.1,34C118.1,32.2 123.6,30.3 123.6,24.8C123.6,23.3 122.8,22.3 121.7,22.3C120.3,22.3 117.6,24.2 115.8,30.5L115.8,40.7C115.8,41.8 115.9,43.2 114.1,43.2C112.9,43.2 111.3,42.8 111.3,40.6L111.3,5Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,35.5C137.7,37.5 139.3,39.2 142.4,39.2C147,39.2 148.9,35.4 149.6,31.7C150.1,29 153.4,30.2 153.2,32.3C152.8,35.9 150.4,43.1 141.7,43.1C136.3,43.1 131.2,38.8 131.2,31.4C131.2,23.9 135.7,18.3 140.3,18.3C143.6,18.3 145.6,20.7 145.6,24.3C145.6,28.6 142.6,33.8 136.9,35.5ZM136.2,32.2C139.2,30.8 141.1,27.8 141.1,24.2C141.1,22.9 140.6,22.1 139.9,22.1C137,22.1 136.1,28.6 136.2,31.1C136.1,31.5 136.2,31.9 136.2,32.2Z",
    style: {
      fill: "rgb(255,253,248)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritelikeWhite);
export default __webpack_public_path__ + "static/media/writelike-white.5ee5cbc42954e19dc6e8127c495845a1.svg";
export { ForwardRef as ReactComponent };